var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 409.6",
    style: {
      enableBackground: "new 0 0 350 409.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#2A4147;enable-background:new    ;}\n\t.st1{fill:#FF3535;}\n\t.st2{opacity:0.92;fill:#231F20;}\n\t.st3{fill:#231F20;}\n\t.st4{fill:#AB1E2F;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{font-family:'Roboto-Regular';}\n\t.st7{font-size:35px;}\n\t.st8{font-family:'Roboto-Medium';}\n\t.st9{font-size:16px;}\n\t.st10{font-family:'Roboto-Bold';}\n\t.st11{font-size:43px;}\n\t.st12{font-size:22px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7610",
    transform: "translate(-500 -3996.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    className: "st0",
    d: "M816.5,4035.4v-33.3h-283v65.5H500v27.2l33.5,24.6v200.5l15.6,6.3v17.8l125.9,62.4l125.9-62.4 v-17.8l15.6-6.3v-200.5l33.5-24.6v-27.2h-33.5V4035.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    className: "st1",
    d: "M531.8,4015v318.8l143.2,59.4l143.2-59.4V4015H531.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    className: "st2",
    d: "M522,3996.7v324.5l153.3,58.4l153.3-58.4v-324.5L522,3996.7L522,3996.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1291",
    x: 521.7,
    y: 4081,
    className: "st3",
    width: 306.5,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    x: 521,
    y: 4190.3,
    className: "st3",
    width: 306.5,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    x: 500,
    y: 4009.6,
    className: "st1",
    width: 350,
    height: 62.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    className: "st4",
    d: "M500,4072.4l21.7,18.8v-18.8H500z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    className: "st4",
    d: "M850,4072.4l-21.7,18.8v-18.8H850z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 606.128 4053.311)",
    className: "st5 st6 st7"
  }, "Premium"), /*#__PURE__*/React.createElement("g", {
    id: "Group_7605",
    transform: "translate(0 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    className: "st1",
    d: "M735.6,4344.2h-122c-4.1,0-7.4-4.3-7.4-9.5v-17.5c0-5.2,3.3-9.5,7.4-9.5h122 c4.1,0,7.4,4.3,7.4,9.5v17.5C743,4339.9,739.7,4344.2,735.6,4344.2z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 630 4331.1069)",
    className: "st5 st8 st9"
  }, "More Details")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7607",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 638 4128)",
    className: "st5 st10 st11"
  }, "$29"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 624 4161)",
    className: "st5 st6 st12"
  }, "Per Month")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7606",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 626 4239)",
    className: "st5 st10 st11"
  }, "$329"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 633 4274)",
    className: "st5 st6 st12"
  }, "Per Year")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium-plan.ac19d0733a05b4ca829443e7705cd8ef.svg";
export { ForwardRef as ReactComponent };